import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import * as React from 'react';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function EvaluationDeclaration(props) {
    const { setOpenDecl, openDecl } = props

    
    const handleClose = () => {
        setOpenDecl(false);
        //navigate
    };


    const onAccept = () => {
        setOpenDecl(false);
    };


    return (
        <div>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDecl}

            >
                <DialogContent sx={{ margin: "30px" }}>
                <DialogContent dividers>
                    <Typography variant='Label20' fontWeight={"bold"}>
                        Please Note:
                    </Typography>
                    <Typography variant='body2'>
                        1. We give loans for education in India only.
                    </Typography>
                    <Typography variant='body2'>
                        2. We do not give any moratorium on repayment of loan.
                    </Typography>
                    <Typography variant='body2'>
                        3. Applicant must be 21 years of age and must have income of his/her own.
                    </Typography>
                </DialogContent>

                </DialogContent>
                <div style={{ padding: "5px 40px 20px", display: "flex", flexDirection: "row", justifyContent: "center" }}>                   
                        <Button
                            type="button"
                            sx={{ fontStyle: "Lato" }}
                            color="neutral"
                            variant="contained"
                            onClick={onAccept}
                        >
                            Proceed
                        </Button>
                    

                    </div>
            </BootstrapDialog>
        </div>
    );
}
